import { useAppStore } from "@/stores/appStore";

const authInit = new Promise((resolve) => {
  resolve();
});

export default (to, from, next) => {
  const requireAuth = to.matched.some((record) => record.meta.requireAuth);
  const requireSalaryAuth = to.matched.some(
    (record) => record.meta.requireSalaryAuth
  );
  authInit.then(async () => {
    const store = useAppStore();
    if (requireAuth && !store.isLogin) {
      next({ path: "/login", query: to.query });
    } else {
      if (requireSalaryAuth) {
        await store.getOneTimeSalaryToken();
        if (!store.salaryToken) {
          next({ path: "/salary-login" });
        } else {
          next();
        }
      } else {
        next();
      }
    }
  });
};
